import PropTypes from "prop-types";
import React from "react";
import { useClipboard } from "use-clipboard-copy";

const MeterAccessConfigPanel = ({ meter }) => {
  // Not sure if we need the full meter or just the access info...

  return (
    <div className="bg-white pb-4 mb-4 rounded">
      <div className="mx-4 pt-2 text-lg font-medium border-b border-gray-600">
        Access Config
      </div>
      <div className="mx-4 mt-2 flex flex-col">
        <CopyableField value={meter.ip} />
        <CopyableField value={meter.accessToken} />
      </div>
    </div>
  );
};

MeterAccessConfigPanel.propTypes = {
  meter: PropTypes.object
};

export default MeterAccessConfigPanel;

const CopyableField = ({ value }) => {
  const clipboard = useClipboard({
    copiedTimeout: 800
  });
  return (
    <div className="flex items-baseline">
      <input
        ref={clipboard.target}
        className="input truncate"
        value={value}
        readOnly
      />
      {!clipboard.copied && (
        <div onClick={clipboard.copy} className="ml-2 text-xl h-full">
          <span className="fa-fw far fa-copy" />
        </div>
      )}
      {clipboard.copied && (
        <div className="ml-2 text-xl h-full">
          <span className="fa-fw far fa-check-circle" />
        </div>
      )}
    </div>
  );
};

CopyableField.propTypes = {
  value: PropTypes.string.isRequired
};
